// While "Add waypoint" mode is on, the map shows a pin cursor whose tip marks the exact point the
// waypoint will drop on, instead of Mapbox's grab hand. Driven by a class on <body> so it applies
// to whichever map the page hosts; the CSS lives in WaypointAddingNotification.vue.

export const WAYPOINT_ADDING_BODY_CLASS = 'waypoint-adding-mode';

export function applyWaypointAddingCursor(enabled: boolean, body: HTMLElement = document.body): void {
  body.classList.toggle(WAYPOINT_ADDING_BODY_CLASS, enabled);
}
